export enum EDietStatusList {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	ALL = 'all',
}

export enum EDietStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	ARCHIVED = 'archived',
}

export enum EDietCreateTabs {
	GENERAL = 'general',
	MEALS = 'meals',
	CALORIES = 'calories',
	PROHIBITED_ALERGENS = 'prohibited_alergens',
	MARKETING = 'marketing',
}

export enum EDietType {
	STANDARD = 'standard',
	MENU_SELECTION = 'menu_selection',
}
